export const isDefined = <T>(x: T | undefined): x is T => x !== undefined;

export const toNonEmptyObjectOrUndefined = <T extends object>(o: T | null | undefined) => {
  if (!o || Object.entries(o).length === 0) return undefined;
  return o;
};
